import NavBase from './base';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import createFocusTrap from 'focus-trap';

const namespace = 'header-desktop';
const focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const $ = jQuery;
export default class NavDesktop extends NavBase {
	init() {
		this.searching = false;
		this.states = [];
		this.$subnav = this.$el.find('.header-nav__subnav');
		this.clearTheDecks = false;
		this.isSmallerDropdown = $('body').hasClass('smaller-dropdown');
	}

	enable() {
		this.$el.on(
			`click.${namespace}`,
			'.header-nav__menu > li > a:not([data-search-toggle])',
			e => this.clickItem(e)
		);
		this.$el.on(
			`click.${namespace}`,
			'.header-nav__subnav [data-action="close"], .header-search .mdi-close',
			e => {
				if( this.states.length ){
					window.history.back();
				}
			}
		);
		this.$el.on(
			`click.${namespace}`,
			'a[data-search-toggle]',
			e => { e.preventDefault(); this.showSearch(); }
		);
		this.$el.on(
			`mouseenter.${namespace}`,
			'.header-nav__menu > li > a',
			e => this.mouseEnterItem(e)
		);
		this.$el.on(
			`click.${namespace} focus.${namespace}`,
			'.header-subnav__primary a',
			e => this.hoverSubnav(e)
		);
		this.$el.on(
			`mouseenter.${namespace}`,
			'.header-subnav__primary a',
			e => this.mouseEnterSubnavItem(e)
		)
		this.$el.on(
			`mousemove.${namespace}`,
			'.header-subnav__primary a',
			e  => this.mouseMoveSubnavItem(e)
		);
		this.$el.on(
			`mouseleave.${namespace}`,
			'.header-subnav__primary a',
			e => this.mouseLeaveSubnavItem(e)
		);
		this.$el.on(
			`click.${namespace}`,
			'a',
			e => this.onHeaderLinkClick(e)
		)
		this.$el.on(
			`click.${namespace}`,
			'.header-nav__subnav-scroller',
			e => {
				if(e.target == e.currentTarget && this.states.length ){
					window.history.back();
				}
			}
		)

		this.header.$searchInput.on('focus notempty', e => this.showSearch());
		this.header.$searchInput.on('empty', e => {
			
		});
		this.focusTrap = createFocusTrap(this.$el[0], {
			allowOutsideClick: true
		});

		// listen for popstate
		$(window).on('popstate', e => this.onPopState(e) );

		if (window.history.scrollRestoration) {
			window.history.scrollRestoration = "manual";
		}
	}


	disable() {
		this.$el.off(`.${namespace}`);
		this.hideSearch();
		this.close();
	}

	scrollIntoView() {
		const y = this.$el[0].offsetTop;
		if (y) {
			window.scrollTo({
				top: y,
				behavior: 'smooth'
			})
		}
	}

	showSearch( pushState = true ) {
		
		if (this.searching) {
			return;
		}
		this.scrollIntoView();
		this.searching = true;
		this.restoreDropdown = $('html').hasClass('show-header-nav');
		this.hideDropdown();
		if( pushState ) this.pushState({
			search: true
		});
		disableBodyScroll(this.$el.find('.header-search-results')[0], {
			reserveScrollBarGap: true
		});
		this.focusTrap.activate();
		$(window).on(`keydown.${namespace}`, e => this.onKeyPress(e));
		$('html').addClass('show-search-results');
		this.header.$searchInput.focus();
	}

	hideSearch() {
		$('html').removeClass('show-search-results');
		enableBodyScroll(this.$el.find('.header-search-results')[0]);
		this.focusTrap.deactivate();
		this.searching = false;
		if (this.restoreDropdown) {
			this.showDropdown();
			this.restoreDropdown = false;
		}
	}

	close(navOnly) {
		this.$el.find(`[data-menu="${this.current}"]`)
			.removeClass('-open')
			.addClass('-closed');
		this.current = null;
		if (!navOnly) {
			this.hideDropdown();
		}
	}

	closeOthers() {
		this.$el.find(`.-open:not([data-menu="${this.current}"])`)
			.removeClass('-open')
			.addClass('-closed');
	}

	hideDropdown() {
		enableBodyScroll(this.$subnav[0]);
		$(window).off(`keydown.${namespace}`);
		$('html').removeClass('show-header-nav');
		$(document).off(`focusin.${namespace}`);
		this.$el.off(`keydown.${namespace}`);
	}

	showDropdown( ) {

		disableBodyScroll(this.$subnav[0], {
			reserveScrollBarGap: true
		});
		this.scrollIntoView();
		$(window).on(`keydown.${namespace}`, e => this.onKeyPress(e));
		$('html').addClass('show-header-nav');
		$(document).on(`focusin.${namespace}`, e => this.onFocusIn(e));
		this.$el.on(
			`keydown.${namespace}`,
			'.header-nav__menu > li.-open > a',
			e => this.focusFirstSubItem(e)
		);
		this.$el.on(
			`keydown.${namespace}`,
			'.header-nav__menu > li.-open + li > a',
			e => this.focusLastSubItem(e)
		);
		this.$el.on(
			`keydown.${namespace}`,
			'.header-subnav a',
			e => this.focusNextItem(e)
		);
	}

	focusFirstSubItem(e) {
		if (e && e.which && e.which == 9 && !e.shiftKey) {
			e.preventDefault();
			this.$subnav.find(focusable).first().focus();
		}
	}

	focusLastSubItem(e) {
		if (e && e.which && e.which == 9 && e.shiftKey) {
			e.preventDefault();
			this.$subnav.find(focusable).last().filter(':visible').focus();
		}
	}

	focusNextItem(e) {
		if (e && e.which && e.which == 9 && !e.shiftKey) {
			if ($(e.target).is(this.$subnav.find(focusable).filter(':visible').last())) {

			}
		}
	}

	onFocusIn(e) {
		if (!this.$el.is(e.target) && !$.contains(this.$el[0], e.target)) {
			e.preventDefault();
			setTimeout(() => {
				this.$el.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first().focus();
			}, 0);
		}
	}

	onKeyPress(e) {
		if (e.which === 27) {
			if (this.searching) {
				this.header.$searchInput.val('').trigger('input empty');
			}
			if( this.states.length ){
				window.history.back();
			}
		}
	}

	open(name) {
		if( !this.current ){
			this.pushState({
				dropdown: true
			});
		}
		this.current = name;
		this.closeOthers();

		this.$el.find(`[data-menu="${this.current}"]`)
			.removeClass('-closed')
			.addClass('-open');

		// find the subnav with the id

		this.showDropdown();
		this.showSubnav(this.current + '_default');
	}

	mouseEnterSubnavItem(e){
		const $a = $(e.currentTarget);
		const target = $a.data('target');
		$a.data('hover', setTimeout(() => this.showSubnav(target)));
	}

	mouseMoveSubnavItem(e){
		const $a = $(e.currentTarget);
		const target = $a.data('target');
		const timeout = $a.data('hover');
		if( timeout ){
			clearTimeout(timeout);
		}
		$a.data('hover', setTimeout(() => this.showSubnav(target), 80));
	}

	mouseLeaveSubnavItem(e){
		const $a = $(e.currentTarget);
		const target = $a.data('target');
		const timeout = $a.data('hover');
		if( timeout ){
			clearTimeout(timeout);
		}
		$a.data('hover', 0);
	}

	hoverSubnav(e) {
		const $a = $(e.currentTarget);
		const target = $a.data('target');
		this.showSubnav(target);
	}

	showSubnav(id) {
		this.$el.find(`[data-menu="${this.current}"] .header-subnav__secondary-content.-open`).each((i, el) => {
			if ($(el).data('id') !== id) {
				$(el).removeClass('-open');
				$(el).addClass('-closed');
			}
		});
		const $active = this.$el.find(`[data-id="${id}"]`);
		const $anchor = this.$el.find(`[data-target="${id}"]`);
		this.$el.find(`[data-menu="${this.current}"] [data-target]`).not($anchor).removeClass('-active');
		if ($anchor.hasClass('-has-arrow')) {
			$anchor.addClass('-active');
		}
		if ($active.hasClass('-open')) {
			return;
		}
		if (this.transition) {
			this.transition.reject();
		}
		$active.removeClass('-closed');
		this.transition = $.Deferred();
		this.transition.always(() => {
			delete this.transition;
		});
		this.transition.fail(() => {
			clearTimeout(this.transitionTimeout);
			$active.addClass('-closed');
		});
		this.transition.done(() => {
			$active.addClass('-open')
		});
		this.transitionTimeout = setTimeout(() => {
			this.transition.resolve();
		}, 10);
	}

	clickItem(e) {
		e.preventDefault();
		const $li = $(e.target).closest('li');
		const name = $li.data('menu');
		if (this.current && this.current === name) {
			if( this.states.length ){
				window.history.back();
			}
		} else {
			$(window).off(`keydown.${namespace}`);
			this.open(name);
		}
	}

	mouseEnterItem(e) {
		e.preventDefault();
		const $li = $(e.target).closest('li');
		const name = $li.data('menu');
		if (this.current && this.current === name) {
			this.showSubnav(this.current + '_default');
		}
	}

	pushState(state){
		this.states.push(state);
		window.history.pushState(state,'');
	}

	onPopState(e){
		if( this.clearTheDecks ){
			return;
		}
		if( this.states.length ){
			this.states.pop();
		}
		else {
			return;
		}
		if( this.states.length ){
			if( this.states[this.states.length-1].dropdown ){
				this.hideSearch();
			}
			else if( this.states[this.states.length-1].search ){
				this.hideDropdown();
			}
		}
		else {
			this.close();
			this.hideSearch();
		}
	}

	onHeaderLinkClick(e){
		if( e.isDefaultPrevented() ){
			return;
		}
		if( this.states.length ){
			this.clearTheDecks = true;
			while( this.states.length ){
				this.states.pop();
				window.history.back();
			}
			window.location = e.currentTarget.href;
			return;
		}
	}
}